import Edison1 from '../Edison/Edison (1).webp'
import Edison2 from '../Edison/Edison (2).webp'
import Edison3 from '../Edison/Edison (3).webp'

const Edisonimages =[
Edison1,Edison2,Edison3
]

export default Edisonimages;